import { type ApplicationsAction, ApplicationsActionNames } from './actions';
import { type IApplicationsState } from './interfaces';

const initialState = {
  loadedWidgets: [],
  loadedFullscreenWidgets: [],
  widgetsEnabled: true,
};

export const applicationsReducer = (
  state: IApplicationsState = initialState,
  action: ApplicationsAction
): IApplicationsState => {
  switch (action.type) {
    case ApplicationsActionNames.LOAD_WIDGET:
      if (!state.loadedWidgets.includes(action.payload.id)) {
        return {
          ...state,
          loadedWidgets: [...state.loadedWidgets, action.payload.id],
        };
      }

      return state;

    case ApplicationsActionNames.LOAD_FULLSCREEN_WIDGET:
      if (!state.loadedFullscreenWidgets.includes(action.payload.id)) {
        return {
          ...state,
          loadedFullscreenWidgets: [...state.loadedFullscreenWidgets, action.payload.id],
        };
      }

      return state;

    case ApplicationsActionNames.WIDGETS_DISABLE: {
      return {
        ...state,
        widgetsEnabled: false,
      };
    }
    default:
      return state;
  }
};
